var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialPhone = function SvgD28SocialPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-28-social-phone_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.152941 0 0 0 0 0.149020 0 0 0 0 0.164706 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d-28-social-phone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.194 20.969c-.609 0-1.464-.22-2.744-.936-1.557-.873-2.761-1.679-4.31-3.223-1.492-1.492-2.219-2.458-3.236-4.308-1.148-2.09-.953-3.184-.734-3.652.26-.56.646-.894 1.143-1.226a5.497 5.497 0 0 1 .98-.512c.153-.07.387-.175.683-.062.198.074.375.226.65.498.567.56 1.342 1.804 1.627 2.415.192.412.319.684.32.988 0 .358-.18.633-.398.93-.041.056-.082.11-.121.16-.237.313-.29.403-.255.564.07.323.588 1.286 1.44 2.136.852.85 1.787 1.336 2.112 1.405.167.036.26-.018.581-.264l.143-.108c.333-.247.595-.422.944-.422h.002c.303 0 .563.131.993.348.561.283 1.843 1.048 2.405 1.615.274.275.426.451.5.649.113.297.007.53-.061.686l-.038.085c-.131.311-.291.61-.477.892-.331.495-.667.88-1.228 1.14a2.104 2.104 0 0 1-.921.202z",
    fill: "#000",
    fillRule: "nonzero"
  })))));
};
export default SvgD28SocialPhone;